export { version } from './src/package.js'
import { urlchange } from './src/urlchange.js'

if (typeof jQuery != 'undefined') {
  jQuery.extend(jQuery.fn, {
    urlchange: urlchange
  })
}
